import { LazyRenderLayer } from 'core/layouts/ui-blocks/ReusableComponents';
import { ComponentLoadingScreen } from 'core/navigation/loading-screen/LoadingScreen';
import { homePageTrueTouchModelSelector } from 'core/store/reducers/homeReducer/HomeSlice';
import React, { lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';

const TrueTouchModal = lazy(() => import('./TrueTouchModal'));

function LazyTrueTouchModal() {
	const isModalOpen = useSelector(homePageTrueTouchModelSelector);

	return (
		<LazyRenderLayer isShown={isModalOpen}>
			<Suspense fallback={<ComponentLoadingScreen />}>
				<TrueTouchModal />
			</Suspense>
		</LazyRenderLayer>
	);
}

export default LazyTrueTouchModal;
